import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@projectobelisk/uikit/components/feedback/empty";
import { createFileRoute } from "@tanstack/react-router";
import { ChartNoAxesCombined } from "lucide-react";

export const Route = createFileRoute("/_app/speed-to-lead/reports")({
  staticData: { title: "Reports", breadcrumb: "Reports" },
  component: Reports,
});

function Reports() {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <ChartNoAxesCombined />
        </EmptyMedia>
        <EmptyTitle>No reports yet</EmptyTitle>
        <EmptyDescription>
          Reports will appear here once you have campaign data.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
